export const NAV = {
  root: "site-nav",
  brand: "site-brand",
  link: (slug) => `nav-link-${slug}`,
  ctaContact: "nav-cta-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  meaning: "hero-meaning",
  slogan: "hero-slogan",
  ctaStart: "hero-cta-start",
  ctaInstagram: "hero-cta-instagram",
  scrollHint: "hero-scroll-hint",
};

export const MARQUEE = {
  root: "editorial-marquee",
};

export const PILLARS_IDS = {
  root: "pillars-section",
  card: (key) => `pillar-card-${key}`,
};

export const OFFERINGS_IDS = {
  root: "offerings-section",
};

export const MANIFESTO = {
  root: "manifesto-section",
};

export const CONTACT = {
  root: "contact-section",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  sport: "contact-sport",
  level: "contact-level",
  message: "contact-message",
  submit: "contact-submit",
  instagramCta: "contact-instagram",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  root: "site-footer",
  instagram: "footer-instagram",
  email: "footer-email",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
